import { useState, useEffect } from "react";
import Header from "../components/Header";
import LeadCountCard from "../components/LeadCountCard";
import "../styles/Dashboard.css";
import AddLeadModal from "../components/AddLeadModal";
import ActiveLeads from "../components/ActiveLeads";
import InvalidLeads from "../components/InvalidLeads";
import NotQualify from "../components/NotQualify";
import axios from "axios";
import apiBaseUrl from "../config/env";

const Dashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] =
    useState<"active" | "invalid" | "notQualify">("active");
  const [searchQuery, setSearchQuery] = useState("");

  const token = localStorage.getItem("authToken");

  const [leadCounts, setLeadCounts] = useState({
    active: 0,
    invalid: 0,
    notQualify: 0,
  });

  const [visitCounts, setVisitCounts] = useState({
    siteVisit: 0,
    f2f: 0,
    token: 0,
    invalid_count:0,
    active_count:0,
    total_count:0,
    not_qualify:0
  });

  const handleLeadCountUpdate = (
    type: "active" | "invalid" | "notQualify",
    count: number
  ) => {
    setLeadCounts((prev) => ({
      ...prev,
      [type]: count
    }));
  };

  // const totalLeads =
  //   leadCounts.active + leadCounts.invalid + leadCounts.notQualify;

  // FETCH SITE VISIT, F2F, TOKEN DONE COUNTS
  const fetchVisitCounts = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/global-partner-connect/site-visit-count`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.status === "success") {
        setVisitCounts({
          siteVisit: response.data.site_visit_count ?? 0,
          f2f: response.data.f2f_count ?? 0,
          active_count: response.data.active_count ?? 0,
          invalid_count: response.data.invalid_count ?? 0,
          token: response.data.token_done_count ?? 0,
          total_count: response.data.total_count ?? 0,
          not_qualify: response.data.not_qualify ?? 0
        });
      }
    } catch (error) {
      console.error("Error fetching visit counts:", error);
    }
  };

  useEffect(() => {
    fetchVisitCounts();
  }, []);

  const renderLeadComponent = () => {
    switch (activeTab) {
      case "active":
        return (
          <ActiveLeads
            onCountUpdate={(count) => handleLeadCountUpdate("active", count)}
            searchQuery={searchQuery}
          />
        );
      case "invalid":
        return (
          <InvalidLeads
            onCountUpdate={(count) => handleLeadCountUpdate("invalid", count)}
            searchQuery={searchQuery}
          />
        );
      case "notQualify":
        return (
          <NotQualify
            onCountUpdate={(count) => handleLeadCountUpdate("notQualify", count)}
            searchQuery={searchQuery}
          />
        );
      default:
        return (
          <ActiveLeads
            onCountUpdate={(count) => handleLeadCountUpdate("active", count)}
            searchQuery={searchQuery}
          />
        );
    }
  };

  return (
    <div className="dashboard">
      <Header />

      <div className="width-set">
        <div className="stats-row">
          <LeadCountCard count={visitCounts.total_count} title="Total Leads" />
          <LeadCountCard count={visitCounts.active_count} title="Active Leads" />
          <LeadCountCard count={visitCounts.invalid_count} title="Invalid Leads" />
          <LeadCountCard count={visitCounts.not_qualify} title="Not Qualify Leads" />

          {/* SITE VISIT, F2F, TOKEN DONE FROM API */}
          <LeadCountCard count={visitCounts.siteVisit} title="Site Visit Done" />
          <LeadCountCard count={visitCounts.f2f} title="F2F Done" />
          <LeadCountCard count={visitCounts.token} title="Token Done" />
        </div>

        <div className="search-add">
          <input
            type="text"
            placeholder="Search leads by customer name..."
            className="search-bar"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button className="add-btn" onClick={() => setShowModal(true)}>
            + Add New Lead
          </button>
        </div>

        <div className="lead-tabs">
          <button
            className={`lead-tab ${activeTab === "active" ? "active" : ""}`}
            onClick={() => setActiveTab("active")}
          >
            Active Leads
          </button>

          <button
            className={`lead-tab ${activeTab === "invalid" ? "active" : ""}`}
            onClick={() => setActiveTab("invalid")}
          >
            Invalid Leads
          </button>

          <button
            className={`lead-tab ${activeTab === "notQualify" ? "active" : ""}`}
            onClick={() => setActiveTab("notQualify")}
          >
            Not Qualify
          </button>
        </div>

        <h3 className="section-title ml-2">
          {activeTab === "active"
            ? `Active Leads (${leadCounts.active})`
            : activeTab === "invalid"
            ? `Invalid Leads (${leadCounts.invalid})`
            : `Not Qualify Leads (${leadCounts.notQualify})`}
        </h3>

        {renderLeadComponent()}

        {showModal && <AddLeadModal onClose={() => setShowModal(false)} />}
      </div>
    </div>
  );
};

export default Dashboard;
